import { commitMutation } from 'react-relay'
import graphql from 'babel-plugin-relay/macro'

import environment from '../../../../environments/pom/Environment'

const mutation = graphql`
  mutation EnqueueLetterMutation($companyId: ID!, $letterId: ID!) {
    Me {
      Company(id: $companyId) {
        businessPost {
          enqueueLetter(id: $letterId)
        }
      }
    }
  }
`

export default (variables = {}, accessToken, callBack, errorCallBack) => {
  commitMutation(environment(accessToken), {
    mutation,
    variables,
    onCompleted: callBack,
    onError: errorCallBack,
  })
}
